

export function takeScreenshot() {
    const canvas = document.getElementsByClassName('v3d-canvas')[0];


    window.screen__img = canvas.toDataURL('image/jpeg');

}

export function getScreenShot() {
    const canvas = document.getElementsByClassName('v3d-canvas')[0];
    return canvas.toDataURL('image/jpeg');
}

export function downloadScreenshot() {
    let el = document.createElement('a');
    el.href = window.screen__img;
    el.download = 'praktik-screenshot';
    el.click();
}
